export const generateGuarantees = ({ paymentData }) => {
  try {
    const guaranteesAccepted = []

    if (paymentData.paymentOption === 'paymentPlan') {
      // Payment plans allow new or saved credit cards.
      return [
        {
          guaranteeTypeCode: 41,
          providerName: 'BookIt',
          paymentInfo: {
            provider:
              paymentData?.paymentCardOption === 'saved-card'
                ? {
                    guaranteeTypeCode: 5,
                    providerName: 'ekashu',
                    paymentCards: [
                      {
                        cardHolderName:
                          paymentData?.savedCardData?.customerNumber,
                        cardNumber: paymentData?.savedCardData?.reference,
                        seriesCode: paymentData?.savedCardSeriesCode || '',
                      },
                    ],
                  }
                : {
                    guaranteeTypeCode: 46,
                    providerName: 'preloadEkashu',
                    paymentInfo: {
                      saveCard: paymentData?.paymentCardOption !== 'saved-card',
                    },
                  },
          },
        },
      ]
    }

    if (paymentData?.paymentOption === 'creditCard') {
      if (paymentData?.paymentCardOption === 'saved-card') {
        guaranteesAccepted.push({
          guaranteeTypeCode: 5,
          providerName: 'ekashu',
          paymentCards: [
            {
              cardHolderName: paymentData?.savedCardData?.customerNumber,
              cardNumber: paymentData?.savedCardData?.reference,
              seriesCode: paymentData?.savedCardSeriesCode || '',
            },
          ],
        })
      } else {
        guaranteesAccepted.push({
          guaranteeTypeCode: 46,
          providerName: 'preloadEkashu',
          paymentInfo: {
            saveCard: !!paymentData?.saveCard,
          },
        })
      }
    }

    const includesNewCard =
      paymentData?.paymentOption === 'creditCard' &&
      paymentData?.paymentCardOption !== 'saved-card'

    const includesSavedCard =
      paymentData?.paymentOption === 'creditCard' &&
      paymentData?.paymentCardOption === 'saved-card'

    if (
      paymentData.pointOption === 'loyaltyPoints' &&
      paymentData?.availableLoyaltyPoints
    ) {
      const redemptionQuantity = Math.min(
        +paymentData.totalDue,
        +paymentData.availableLoyaltyPoints,
      )

      guaranteesAccepted.push({
        guaranteeTypeCode: 47,
        loyaltyRedemption: {
          redemptionQuantity,
        },
        calculateOnly: includesNewCard || includesSavedCard,
      })
    }

    if (
      paymentData.pointOption === 'travelCard' &&
      paymentData?.travelCard?.balance
    ) {
      const redemptionQuantity = Math.min(
        +paymentData.travelCard.balance,
        +paymentData.totalDue,
      )
      guaranteesAccepted.push({
        guaranteeTypeCode: 15,
        loyaltyRedemption: {
          redemptionQuantity,
        },
        paymentCards: [
          {
            seriesCode: paymentData.travelCardPin,
          },
        ],
        calculateOnly: includesNewCard || includesSavedCard,
      })
    }

    if (paymentData.paymentOption === 'payPal') {
      guaranteesAccepted.push({
        guaranteeTypeCode: 46,
        providerName: 'paypal',
        paymentInfo: paymentData.payPalResponse,
      })
    }

    return guaranteesAccepted
  } catch (err) {
    throw new Error(`Payment form error: ${err?.message || ''}.`)
  }
}
